<template>
  <div class="logo-download">
    <ZInfo title="自如品牌标志 Ziroom Logo">
      <p class="desc">
        自如是一家提供高品质居住产品与生活服务的科技公司，成立于2011年10月18日。
      </p>
      <p class="desc">
        发展至今七年。自如已在北京、上海、深圳、杭州、南京、广州、成都、天津、武汉九座城市布局，服务近200万租客。自如旗下拥有自如友家、自如整租、业主直租、自如
        豪宅、自如寓、自如驿、自如ZSPACE等产品，为用户提供保洁、搬家、维修等服务。自如通过现代科技的广泛应用，为人们提供了更每换的居住体验，更会引领居住消费市场向高质量发展。
      </p>
      <p class="desc">
        在自如集团标志(Ziroom
        Logo)上，从品牌形象的对应程度、各类渠道的易用性到视觉的平衡度，设计中心品牌团队打造了自如的集团标志，为确保品牌传达的一致性及专业性，请严格按照相关使用建议使用集团标志，如有疑虑可以联系
        设计中心 <b>＠赵思远</b>。
      </p>
    </ZInfo>
    <div class="logo-card-wrapper container">
      <tabs v-if="brands.length">
        <tab
          :title="brand.groupName"
          v-for="brand in brands"
          :key="brand.groupName"
        >
          <LogoCard
            v-for="source in brand.sources"
            :key="source.name"
            :logoInfo="source"
          ></LogoCard>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab } from "@/components/Tabs";
import ZInfo from "@/components/ZInfo.vue";
import LogoCard from "@/components/LogoCard.vue";
import axios from 'axios';

export default {
  data() {
    return {
      brands: []
    };
  },
  components: {
    ZInfo,
    LogoCard,
    Tabs,
    Tab,
  },
  methods: {
    getBrands() {
      axios.post('http://banana.ziroom.com/brandplatform/api/ziroomsource', { sortBy: '-_id'}).then((res) => {
        try {
          this.brands = res.data.data.list;
        } catch (error) {
          console.log(error);
        }
      })
    }
  },
  // vue mounted生命周期
  mounted() {
    this.getBrands()
  },
};
</script>

<style lang="scss" scoped>
.logo-download {
  margin-bottom: 50px;
  .logo-card-wrapper {
  }
}
</style>